import { PagedFilterAndSortedRequest } from 'services/dto';

export interface Vehicle {
  id: string;
  registrationNumber: string;
  euroStatus?: string;
  motStatus?: string;
  typeApproval?: string;
  wheelplan?: string;
  taxStatus?: string;
  colour?: string;
  mileage?: number;
  markedForExport?: boolean;
  co2?: number;
  dvlaYearOfManufacture?: string;
  engineNumber?: number;
  grossWeightKg?: number;
  numberOfPreviousKeepers?: string;
  startDateOfCurrentKeeper?: string;
  combinedVin: string;
  combinedMake?: string;
  combinedModel?: number;
  combinedEngineCapacity?: string;
  combinedFuelType?: string;
  combinedTransmission?: number;
  combinedForwardGears?: string;
  aspiration?: string;
  bodyStyleDescription?: string;
  numberOfDoors?: string;
  driveAxle?: string;
  driveType?: string;
  engineModelCode?: string;
  nomCc?: number;
  heightMm?: number;
  lengthMm?: number;
  widthMm?: number;
  kerbWeightMin?: number;
  maximumPowerInKw?: string;
  maximumPowerBhp?: string;
  modelSeries?: string;
  vehicleCategoryDescription?: string;
  dateFirstRegistered?: Date;
  taxDueDate?: Date;
  dateOfLastV5CIssued?: Date;
  motExpiryDate?: Date;
  introductionDateToUk?: Date;
  vehicleImageUrl?: string;
  manuallyAdded?: boolean;
}

export interface CreateVehicle {
  registrationNumber: string;
  euroStatus?: string;
  motStatus?: string;
  typeApproval?: string;
  wheelplan?: string;
  taxStatus?: string;
  colour?: string;
  mileage?: number;
  markedForExport?: boolean;
  co2?: number;
  dvlaYearOfManufacture?: string;
  engineNumber?: number;
  grossWeightKg?: number;
  numberOfPreviousKeepers?: string;
  startDateOfCurrentKeeper?: string;
  combinedVin?: string;
  combinedMake?: string;
  combinedModel?: number;
  combinedEngineCapacity?: string;
  combinedFuelType?: string;
  combinedTransmission?: number;
  combinedForwardGears?: string;
  aspiration?: string;
  bodyStyleDescription?: string;
  numberOfDoors?: string;
  driveAxle?: string;
  driveType?: string;
  engineModelCode?: string;
  nomCc?: number;
  heightMm?: number;
  lengthMm?: number;
  widthMm?: number;
  kerbWeightMin?: number;
  maximumPowerInKw?: string;
  maximumPowerBhp?: string;
  modelSeries?: string;
  vehicleCategoryDescription?: string;
  dateFirstRegistered?: Date;
  taxDueDate?: Date;
  dateOfLastV5CIssued?: Date;
  motExpiryDate?: Date;
  introductionDateToUk?: Date;
}

export type UpdateVehicle = Partial<Vehicle>;

export type RefreshVehicleData = Pick<Vehicle, 'registrationNumber'> & { vin: string };

export type UpdateVehicleMileage = Pick<Vehicle, 'id' | 'mileage'>;

export const InitialVehicle: CreateVehicle = {
  registrationNumber: '',
  euroStatus: undefined,
  motStatus: undefined,
  typeApproval: undefined,
  wheelplan: undefined,
  taxStatus: undefined,
  colour: undefined,
  mileage: undefined,
  markedForExport: undefined,
  co2: undefined,
  dvlaYearOfManufacture: undefined,
  engineNumber: undefined,
  grossWeightKg: undefined,
  numberOfPreviousKeepers: undefined,
  startDateOfCurrentKeeper: undefined,
  combinedVin: undefined,
  combinedMake: undefined,
  combinedModel: undefined,
  combinedEngineCapacity: undefined,
  combinedFuelType: undefined,
  combinedTransmission: undefined,
  combinedForwardGears: undefined,
  aspiration: undefined,
  bodyStyleDescription: undefined,
  numberOfDoors: undefined,
  driveAxle: undefined,
  driveType: undefined,
  engineModelCode: undefined,
  nomCc: undefined,
  heightMm: undefined,
  lengthMm: undefined,
  widthMm: undefined,
  kerbWeightMin: undefined,
  maximumPowerInKw: undefined,
  maximumPowerBhp: undefined,
  modelSeries: undefined,
  vehicleCategoryDescription: undefined,
  dateFirstRegistered: undefined,
  taxDueDate: undefined,
  dateOfLastV5CIssued: undefined,
  motExpiryDate: undefined,
  introductionDateToUk: undefined,
};

export interface PagedVehicle extends PagedFilterAndSortedRequest {
  registrationNumber?: string | null;
}

export interface UserVehicle {
  id: string;
  vehicle: Vehicle;
}

export interface PagedUserVehicleDto extends PagedFilterAndSortedRequest {
  userId: number;
}

export interface UserVehicleRequestDto {
  userId: number;
  vehicleId?: string;
}

export interface DefectModel {
  text: string;
  type: string;
  dangerous: boolean;
}

export interface MotTest {
  completedDate: string;
  testResult: string;
  expiryDate: string;
  odometerValue: string;
  odometerUnit: string;
  odometerResultType: string;
  motTestNumber: string;
  dataSource: string;
  location: string;
  defects: DefectModel[];
}

export interface MotHistory {
  registration: string;
  make: string;
  model: string;
  firstUsedDate: string;
  fuelType: string;
  primaryColour: string;
  registrationDate: string;
  manufactureDate: string;
  engineSize: string;
  hasOutstandingRecall: string;
  motTests: MotTest[];
}
